import {
  Button,
  CircleXIcon,
  EmptyProps,
  Error,
  ErrorDescription,
  ErrorHeadline,
  useDisclosure,
} from '@frontend/components';

import { SupportDrawer } from 'components/support';

export type GenericErrorProps = EmptyProps;

export const GenericError = ({
  size = 'md',
  ...restProps
}: GenericErrorProps) => {
  const supportDrawerDisclosure = useDisclosure();
  return (
    <>
      <Error size={size} {...restProps}>
        <CircleXIcon color="alert.error" />
        <ErrorHeadline>Something went wrong</ErrorHeadline>
        <ErrorDescription>
          Try reloading the page. If the issue persists,{' '}
          <Button
            size={size}
            variant="link"
            onClick={supportDrawerDisclosure.onOpen}
          >
            contact support
          </Button>
          .
        </ErrorDescription>
      </Error>
      <SupportDrawer {...supportDrawerDisclosure} />
    </>
  );
};
